export const preprints = [
  {
    id: 1,
    info: '1. Alexey A. Dmitriev, Egor D. Demeshko, Danil A. Chernomorov, Andrei A. Mineev, Oleg I. Burmistrov, Sergey S. Ermakov, Alina D. Rozenblit, Pavel S. Seregin, Nikita A. Olekhno, A rechargeable AA battery supporting Qi wireless charging, arXiv:2408.09852 (2025)',
    link: 'https://doi.org/10.48550/arXiv.2408.09852',
  },
  {
    id: 2,
    info: null,
    link: null,
  },
  {
    id: 3,
    info: null,
    link: null,
  },
];

export const journal_articles = [
  {
    id: 1,
    info: '1. Alexey Dmitriev, Vadim Porvatov, Alina Rozenblit, Mikhail Buzakov, Anastasia Molodtsova, Daria Sennikova, Vyacheslav Smirnov, Oleg Burmistrov, Timur Karimov, Ekaterina Puhtina, Nikita Olekhno, Swarmodroid and AMPy: Reconfigurable Bristle-Bots & Software Package for Robotic Active Matter Studies, IEEE Access 13, 212719-212734 (2025)',
    link: 'https://ieeexplore.ieee.org/document/11278164',
    linkArxiv: 'https://doi.org/10.48550/arXiv.2305.13510',
  },
  {
    id: 2,
    info: '2. Anastasia A. Molodtsova, Mikhail K. Buzakov, Oleg I. Burmistrov, Alina D. Rozenblit, Vyacheslav A. Smirnov, Daria V. Sennikova, Vadim A. Porvatov, Ekaterina M. Puhtina, Alexey A. Dmitriev, Nikita A. Olekhno, Micellization in active matter of asymmetric self-propelled particles: Experiments, Physical Review E 111(6), 065424 (2025)',
    link: 'https://journals.aps.org/pre/abstract/10.1103/4yzc-ppgy',
    linkArxiv: 'https://doi.org/10.48550/arXiv.2305.16659',
  },
  {
    id: 3,
    info: '3. Alina D. Rozenblit, Georgiy D. Kurganov, Dmitry V. Zhirihin, Nikita A. Olekhno, Topological edge states in all-dielectric square-lattice arrays of bianisotropic microwave resonators, Physical Review B 111(8), 085415 (2025)',
    link: 'https://journals.aps.org/prb/abstract/10.1103/PhysRevB.111.085415',
    linkArxiv: 'https://doi.org/10.48550/arXiv.2406.15246',
  },
];

export const conference_papers = [
  {
    id: 1,
    info: '1.	A. Rozenblit, M. Buzakov, A. Molodtsova, A. Dmitriev, N. Olekhno, Traffic jam formation in swarms of robots moving along a circular track with a constriction, IEEE Xplore, 18th International Conference on Managment of Large-Scale System Development (MLSD), 1-4 (2025)',
    link: 'https://ieeexplore.ieee.org/document/11220665',
  },
  {
    id: 2,
    info: '2.	M. K. Buzakov, V. A. Smirnov, D. V. Sennikova, A. A. Molodtsova, A. D. Rozenblit, P. V. Porvatov, O. I. Burmistrov, E. M. Puhtina, A. A. Dmitriev, N. A. Olekhno, Crystallization of robotic swarms in a parabolic potential, St. Petersburg State Polytechnical University Journal. Physics and Mathematics, 16(3.1), 36-40 (2023)',
    link: 'https://physmath.spbstu.ru/en/article/2023.68.6/',
  },
  {
    id: 3,
    info: '3.	A.A. Dmitriev, A.D. Rozenblit, V.A. Porvatov, A.A. Molodtsova, E.M. Puhtina, O.I. Burmistrov, D.S. Filonov, A. Souslov, and N.A. Olekhno, Statistical Correlations in Active Matter Based on Robotic Swarms, IEEE Xplore, 2021 International Conference Engineering and Telecommunication (En&T), 1-3 (2022)',
    link: 'https://ieeexplore.ieee.org/document/9681775',
  },
  {
    id: 4,
    info: '4.	V.A. Porvatov, A.D. Rozenblit, A.A. Dmitriev, O.I. Burmistrov, D.A. Petrova, G.Yu. Gritsenko, E.M. Puhtina, E.I. Kretov, D.S. Filonov, A. Souslov, and N.A. Olekhno, Optimizing self-rotating bristle-bots for active matter implementation with robotic swarms, Journal of Physics: Conference Series 2086, 012202 (2021)',
    link: 'https://doi.org/10.1088/1742-6596/2086/1/012202',
  },
  {
    id: 5,
    info: '5.	A.D. Rozenblit, V.A. Porvatov, D.A. Petrova, I.S. Khakhalin, K.P. Kotlyar, G.Yu. Gritsenko, A.A. Evreiskaya, M.F. Lebedeva, E.I. Kretov, D.S. Filonov, A. Souslov, and N.A. Olekhno, Diffusive dynamics and jamming in ensembles of robots with variable friction, Journal of Physics: Conference Series 1695, 012201 (2020)',
    link: 'https://doi.org/10.1088/1742-6596/1695/1/012201',
  },
];
